import React, { useEffect, useState } from 'react';
import ProductCarousel from '../ProductCarousel';
import ProductDetails from '../ProductDetails';
import './styles.css';
import { getProductById } from '../../../../../../../api/products';
import { setLoadingStatus } from '../../../../../../../reducers/notification';

const CollectionProduct = ({ selectedProduct }) => {
  const [images, setImages] = useState(selectedProduct?.url ? [selectedProduct?.url] : selectedProduct?.images?.map(item => item.sourceUrl) ?? []);
  const [product, setProduct] = useState(selectedProduct);

  useEffect(() => {
    if(selectedProduct?.viewDetails) {
      setLoadingStatus(true);
      getProductById(selectedProduct.id).then((({data}) => {
        if(data?.images?.length > 0) {
        setImages(data.images.map(img => img.url))
        } else {
          setImages([])
        }
        setProduct({...data, viewDetails: true})
        setLoadingStatus(false)
      }))
    }
  }, [])
  return (
    <div className="clients-v2-collection-product">
      <ProductCarousel images={images} product={product} />
      <ProductDetails product={product} />
    </div>
  );
};

export default CollectionProduct;
